// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"8edcc868","782":"ce1906f6"}[chunkId] + ".chunk.js";
};